/** Sum breakdown amounts for Others (survey / invoice invoice_meta.extra_lines). */
export function sumOthersLineAmounts(rows, { onlySelected = false } = {}) {
  if (!rows || !rows.length) return 0
  return rows.reduce((acc, row) => {
    if (onlySelected && row?.selected === false) return acc
    const n = parseFloat(String(row?.amount ?? '').replace(/,/g, ''))
    return acc + (Number.isFinite(n) ? n : 0)
  }, 0)
}
